import React from "react";
import { Card } from "./card";
import { PlanBadge } from "../plan-badge";
import type { MembershipPlan } from "~/lib/schemas";
import { cn } from "~/lib/utils";

export interface PricingCardProps {
  membershipPlan?: MembershipPlan;
  price?: string;
  priceSuffix?: string;
  description?: string;
  features?: { feature: string }[];
  highlighted?: boolean;
  children?: React.ReactNode;
}

export const PricingCard = (props: PricingCardProps) => {
  const {
    membershipPlan,
    price,
    priceSuffix,
    description,
    highlighted = false,
    children,
  } = props;

  return (
    <Card
      className={cn(
        highlighted &&
          "border-gradient-pro-purple -m-1 rounded-xl p-1 shadow-sm",
      )}
    >
      <div className="flex flex-col items-stretch rounded-lg bg-white/95 p-6">
        {membershipPlan && (
          <div className="self-start">
            <PlanBadge membershipPlan={membershipPlan} />
          </div>
        )}

        {price && (
          <p className="mt-4 text-3xl font-bold">
            {price}
            {priceSuffix && (
              <span className="text-text-tertiary text-sm font-normal">
                {priceSuffix}
              </span>
            )}
          </p>
        )}

        {description && <p className="mt-2 text-gray-600">{description}</p>}

        <div className="mt-6">{children}</div>
      </div>
    </Card>
  );
};
